// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ExpandAllController from "./expand_all_controller"
application.register("expand-all", ExpandAllController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TriggerClickController from "./trigger_click_controller"
application.register("trigger-click", TriggerClickController)

import TurboFetchController from "./turbo_fetch_controller"
application.register("turbo-fetch", TurboFetchController)

import UnitOperationController from "./unit_operation_controller"
application.register("unit-operation", UnitOperationController)
